/* ── PAIRS grouped by category ── */
export const PAIR_GROUPS = [
  {
    label: 'Forex — Majors',
    pairs: ['EURUSD','GBPUSD','USDJPY','USDCHF','USDCAD','AUDUSD','NZDUSD'],
  },
  {
    label: 'Forex — Minors',
    pairs: ['EURGBP','EURJPY','EURCAD','EURAUD','EURNZD','EURCHF',
            'GBPJPY','GBPCAD','GBPAUD','GBPNZD','GBPCHF',
            'AUDJPY','AUDCAD','AUDCHF','AUDNZD',
            'CADJPY','CADCHF','NZDJPY','NZDCAD','NZDCHF','CHFJPY'],
  },
  {
    label: 'Metals',
    pairs: ['XAUUSD','XAGUSD','XAUEUR','XAUGBP'],
  },
  {
    label: 'Indices',
    pairs: ['NASDAQ','US30','US500','GER30','UK100','JP225','AUS200','FRA40'],
  },
  {
    label: 'Crypto',
    pairs: ['BTCUSD','ETHUSD','BNBUSD','SOLUSD','XRPUSD','ADAUSD','DOTUSD','LTCUSD'],
  },
];

/* flat list for filters / stats */
export const PAIRS = PAIR_GROUPS.flatMap(g => g.pairs);

export const SESSIONS  = ['Asian','London','New York','London-NY'];
export const STRATEGIES = [
  'SMC Order Block','ICT FVG','Breaker Block','OTE Setup',
  'Support/Resistance','Killzone Entry','Price Action','Trendline Break','Other',
];
export const EMOTIONS   = ['Calm','Confident','FOMO','Revenge','Anxious','Greedy'];
export const MONTHS     = ['January','February','March','April','May','June','July','August','September','October','November','December'];
export const DAYS_SHORT = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

export const EMOTION_COLORS = {
  Calm:      '#3DBE73',
  Confident: '#4E7FD4',
  FOMO:      '#D94F4F',
  Revenge:   '#FF6B35',
  Anxious:   '#E2A542',
  Greedy:    '#C9A84C',
};

export const MARKET_CONDITIONS = ['Trending','Range','Breakout','News-Driven','Reversal','Consolidation'];
export const HTF_BIAS         = ['Bullish','Bearish','Neutral'];
export const TIMEFRAMES       = ['M1','M5','M15','M30','H1','H4','D1','W1'];
export const SETUP_GRADES     = ['A+','A','B','C'];
export const ENTRY_TYPES      = ['Limit','Market','Confirmation','Stop'];
export const EXIT_TYPES       = ['TP Hit','SL Hit','Manual','Break-Even','Partial'];
export const CONFLUENCE_TAGS  = ['Order Block','FVG','Liquidity Sweep','Break of Structure','Session Killzone','Trendline','EMA Confluence','Supply/Demand','Fibonacci','CHOCH'];

export const NOTE_TEMPLATES = [
  { icon:'🌅', title:'Pre-Market Plan',    body:'<h2>Session Bias</h2><p>Daily bias: </p><p>Key levels: </p><h2>Trade Plan</h2><p>Setup: </p><p>Pairs: </p><p>Risk per trade: </p>' },
  { icon:'📝', title:'Daily Recap',        body:'<h2>What I Did Well</h2><p></p><h2>What to Improve</h2><p></p><h2>Key Lessons</h2><p></p>' },
  { icon:'👁', title:'Watchlist',          body:'<h2>Pairs to Watch</h2><p>1. </p><p>2. </p><p>3. </p><h2>Key Levels</h2><p></p>' },
  { icon:'🧠', title:'Weekly Plan',        body:'<h2>Week Summary</h2><p>P&amp;L: </p><p>Win rate: </p><h2>Goals for Next Week</h2><p></p>' },
  { icon:'🎯', title:'Strategy Note',      body:'<h2>Strategy</h2><p>Setup criteria: </p><h2>Rules</h2><p>Entry: </p><p>Exit: </p>' },
  { icon:'📋', title:'Blank Note',         body:'<p></p>' },
];

export const SEED_TRADES = [
  { id:1,time:'09:15',date:'2025-03-10',pair:'XAUUSD',dir:'BUY',entry:'2145.50',sl:'2138.00',tp:'2162.00',lotSize:0.10,pips:16.50,result:16.50,rr:'2.36',strat:'SMC Order Block',session:'London',emotion:'Calm',notes:'Clean H4 OB with FVG fill.',review:'Exited slightly early.',img:'' },
  { id:2,time:'14:30',date:'2025-03-09',pair:'EURUSD',dir:'SELL',entry:'1.0876',sl:'1.0900',tp:'1.0828',lotSize:0.20,pips:48,result:96,rr:'2.00',strat:'ICT FVG',session:'London-NY',emotion:'Confident',notes:'FVG on M15 aligning with H4 OB.',review:'Good execution.',img:'' },
  { id:3,time:'08:45',date:'2025-03-08',pair:'GBPUSD',dir:'BUY',entry:'1.2732',sl:'1.2700',tp:'1.2800',lotSize:0.15,pips:-48,result:-48,rr:'2.13',strat:'Breaker Block',session:'London',emotion:'FOMO',notes:'Breaker block, entered too late.',review:'Should have waited.',img:'' },
  { id:4,time:'15:20',date:'2025-03-07',pair:'XAUUSD',dir:'SELL',entry:'2168.00',sl:'2178.00',tp:'2143.00',lotSize:0.20,pips:25,result:50,rr:'2.50',strat:'OTE Setup',session:'New York',emotion:'Calm',notes:'OTE at 62% Fib.',review:'Best trade of the week.',img:'' },
  { id:5,time:'02:10',date:'2025-03-06',pair:'USDJPY',dir:'BUY',entry:'149.85',sl:'149.40',tp:'150.90',lotSize:0.30,pips:210,result:210,rr:'2.33',strat:'SMC Order Block',session:'Asian',emotion:'Confident',notes:'Asian range break.',review:'Solid execution.',img:'' },
  { id:6,time:'08:55',date:'2025-03-05',pair:'GBPJPY',dir:'SELL',entry:'191.40',sl:'192.20',tp:'189.80',lotSize:0.10,pips:-80,result:-80,rr:'2.00',strat:'ICT FVG',session:'London',emotion:'Anxious',notes:'FVG but news invalidated.',review:'Too much risk on news day.',img:'' },
  { id:7,time:'09:05',date:'2025-03-04',pair:'XAUUSD',dir:'BUY',entry:'2138.00',sl:'2130.00',tp:'2155.00',lotSize:0.10,pips:17,result:17,rr:'2.13',strat:'Killzone Entry',session:'London',emotion:'Calm',notes:'London killzone, OB+FVG.',review:'Textbook setup.',img:'' },
  { id:8,time:'15:45',date:'2025-03-03',pair:'EURUSD',dir:'BUY',entry:'1.0820',sl:'1.0800',tp:'1.0865',lotSize:0.10,pips:45,result:45,rr:'2.25',strat:'Support/Resistance',session:'New York',emotion:'Confident',notes:'Weekly support reversal.',review:'Moved SL to BE after 20 pips.',img:'' },
];
